import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* badges: start */
    }
    <p><img parentName="p" {...{
        "src": "https://img.shields.io/github/package-json/v/davidruvolo51/rdConvert?color=ACECF7&label=version&logo=R",
        "alt": "GitHub package.json version"
      }}></img></p>
    {
      /* badges: end */
    }
    <h1 {...{
      "id": "introduction",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#introduction",
        "aria-label": "introduction permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Introduction`}</h1>
    <p><strong parentName="p">{`rdConvert`}</strong>{` is an R package for creating a package documentation site using `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com"
      }}>{`Gatsby JS`}</a>{` or your preferred web framework. Included in this package, is a workflow for converting Rd files to markdown using the code documentation started developed by `}<a parentName="p" {...{
        "href": "https://github.com/rocketseat/gatsby-themes"
      }}>{`RocketSeat`}</a>{`. This theme gives you the essential tools for generating a Gatsby site.`}</p>
    <h2 {...{
      "id": "motiviation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#motiviation",
        "aria-label": "motiviation permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Motiviation`}</h2>
    <p>{`My motiviation for this project was to figure out how to integrated R package files with other web frameworks. I use React and Gatsby for other proejcts and I wanted to see if it was possible to create a Gatsby site from R man files. The idea behind this workflow is:`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you want a well-documented nice looking site, then you must document it in your R files!`}</p>
    </blockquote>
    <p>{`This workflow could not be possible without the `}<a parentName="p" {...{
        "href": "https://github.com/quantsch/Rd2md"
      }}>{`Rd2md`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/yihui/Rd2roxygen"
      }}>{`Rd2roxygen`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/r-lib/roxygen2md"
      }}>{`roxygen2md`}</a>{` packages. Alternatively, you can opt out of Gatsby steps and use it as Rd to Md converter.`}</p>
    <h2 {...{
      "id": "have-questions",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#have-questions",
        "aria-label": "have questions permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Have questions?`}</h2>
    <p>{`If you have questions, feel free to open a new issue on `}<a parentName="p" {...{
        "href": "https://github.com/davidruvolo51/rdConvert"
      }}>{`rdConvert GitHub repository`}</a>{`. Take a look at the code and files to see how the project should be structured. Checkout the `}<a parentName="p" {...{
        "href": "https://github.com/rocketseat/gatsby-themes"
      }}>{`RocketSeat Gatsby Theme GitHub repository`}</a>{` for information on customizing the site.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      